import { createFileIcon } from '../createFileIcon/createFileIcon';
import FileIconJsonSizeM from './FileIconJson_size_m';
import FileIconJsonSizeS from './FileIconJson_size_s';

export const FileIconJson = createFileIcon({
  m: FileIconJsonSizeM,
  s: FileIconJsonSizeS,
  name: 'FileIconJson',
});
